module.exports = __webpack_public_path__ + "static/media/Link buttons_PS.f02e0f4e.png";